module.exports = __webpack_public_path__ + "img/qihang_xiangqing_anquan.ccb05b05.png";